/**
 * recommendStore
 */
import Vue from 'vue';
import * as types from '../mutation-types';
import * as urls from '../../config/urls';
import * as helpers from '../../utils/helpers';
import auth from '../../utils/auth';

const RECOMMENDELLIST = 'RECOMMENDELLIST'; // 推荐列表
const HOTRECOMMENDELLIST = 'HOTRECOMMENDELLIST'; // 最热列表
const NEWRECOMMENDELLIST = 'NEWRECOMMENDELLIST'; // 最热列表
const TYPERECOMMENDELLIST = 'TYPERECOMMENDELLIST'; // 最热列表
const UPDATE_NEWRECOMMENDEL_EXTRA_INFO = 'UPDATE_NEWRECOMMENDEL_EXTRA_INFO'; // 最新总数
const UPDATE_HOTRECOMMENDEL_EXTRA_INFO = 'UPDATE_HOTRECOMMENDEL_EXTRA_INFO'; // 最新总数
export default {
    namespaced: true,

    state: {
        // recommend
        recommendList: [],
        typeRecommendList: [],
        recommend: [],
        videoRecommendedlist: [],
        hotRecommendedlist: [],
        newRecommendedlist: [],
        recommendLoading: false,
        recommendExtra: 0,
        recommendQueries: {
            pagination: 1,
            pageSize: 12,
        },
        // 最热
        hotRecomdExtra: 0,
        hotRecomdQueries: {
            pagination: 1,
            pageSize: 12,
        },

        // 最热
        newRecomdExtra: 0,
        newRecomdQueries: {
            pagination: 1,
            pageSize: 12,
        },
    },

    mutations: {
        [types.UPDATE_LIST](state, {
            subject,
            list,
        }) {
            state[`${subject}List`] = list;
        },
        [types.UPDATE_LOADING_STATUS](state, {
            subject,
            isLoading,
        }) {
            state[`${subject}Loading`] = isLoading;
        },
        [types.UPDATE_EXTRA_INFO](state, { subject, extra }) {
            state[`${subject}Extra`] = extra;
        },
        // 推荐列表
        [RECOMMENDELLIST](state, { list }) {
            state.videoRecommendedlist = list;
        },
        // 最热
        [HOTRECOMMENDELLIST](state, { list }) {
            state.hotRecommendedlist = list;
        },
        // 最新
        [NEWRECOMMENDELLIST](state, { list }) {
            state.newRecommendedlist = list;
        },
        // 分类
        [TYPERECOMMENDELLIST](state, { list }) {
            state.typeRecommendList = list;
        },
        [UPDATE_NEWRECOMMENDEL_EXTRA_INFO](state, { subject, extra }) {
            state[`${subject}Extra`] = extra;
        },
        [UPDATE_HOTRECOMMENDEL_EXTRA_INFO](state, { subject, extra }) {
            state[`${subject}Extra`] = extra;
        },

    },

    actions: {
        // 推荐列表
        getRecommendedList({ commit }, queries = {}) {
            const subject = 'recommend';
            const {
                currPage,
                perPageNum,
                ...otherQueries
            } = queries;
            let urlUse = '';

            urlUse = urls.GET_RECOMENTED_LIST;
            const userId = auth.getUserInfo().org_id;
            return new Promise((resolve, reject) => {
                Vue.http.get(urlUse, {
                    params: {
                        pageNumber: perPageNum,
                        offset: (currPage - 1) * perPageNum,
                        recommend: 1,
                        userId, 
                        orderType: 1,
                        ...otherQueries,
                    },
                }).then((response) => {
                    const list = response.data.rows || {};
                    commit(RECOMMENDELLIST, { list });
                    const { total } = response.data;
                    commit(types.UPDATE_EXTRA_INFO, { subject, extra: total });
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

        //  获取热播列表
        getHotVideoList({ commit }, queries = {}) {
            const subject = 'hotRecomd';
            const {
                currPage,
                perPageNum,
                ...otherQueries
            } = queries;
            let urlUse = '';
            if (!auth.checkToken()) {
                urlUse = urls.VIODE_LIST_ISLOGIN;
            } else {
                urlUse = urls.VIODE_LIST_LOGIN;
            }
            const userId = auth.getUserInfo().org_id;
            return new Promise((resolve, reject) => {
             
                const url = urlUse;
                Vue.http.get(urlUse, {
                    params: {
                        pageNumber: perPageNum,
                        userId,
                        offset: (currPage - 1) * perPageNum,
                        ...otherQueries,
                    },
                }).then((response) => {
                    const list = response.data.rows || {};

                    commit(HOTRECOMMENDELLIST, { list });
                    const { total } = response.data;
                    commit(UPDATE_HOTRECOMMENDEL_EXTRA_INFO, { subject, extra: total });
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },
        //  获取最新列表
        getNewVideoList({ commit }, queries) {
            const subject = 'newRecomd';
            const {
                currPage,
                perPageNum,
                ...otherQueries
            } = queries;
            let urlUse = '';
            if (!auth.checkToken()) {
                urlUse = urls.VIODE_LIST_ISLOGIN;
            } else {
                urlUse = urls.VIODE_LIST_LOGIN;
            }

            
            const userId = auth.getUserInfo().org_id;

            return new Promise((resolve, reject) => {
                // let urlhot=urls.GET_HOT_LIST+orgId;
                const url = urlUse;
                Vue.http.get(url, {
                    params: {
                        pageNumber: perPageNum,
                        userId,
                        offset: (currPage - 1) * perPageNum,
                        ...otherQueries,
                    },
                }).then((response) => {
                    const list = response.data.rows || {};
                    commit(NEWRECOMMENDELLIST, { list });
                    const { total } = response.data;
                    commit(UPDATE_NEWRECOMMENDEL_EXTRA_INFO, { subject, extra: total });
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },
        // 获取分类
        getTypeVideoList({ commit, state }, queries) {
            const subject = 'recommend';
            const {
                pagination = state[`${subject}Queries`].pagination,
                pageSize = 20,
                ...otherQueries
            } = queries;
            let urlUse = '';
            if (!auth.checkToken()) {
                urlUse = urls.GET_CHANNEL_ISLIST;
            } else {
                urlUse = urls.GET_CHANNEL_LIST;
            }
            return new Promise((resolve, reject) => {
                Vue.http.post(urlUse, {

                }).then((response) => {
                    const list = response.data || [];
                    commit(TYPERECOMMENDELLIST, { list });
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

    },
};
